import { render, staticRenderFns } from "./fiche.vue?vue&type=template&id=84b481f2"
import script from "./fiche.vue?vue&type=script&lang=js"
export * from "./fiche.vue?vue&type=script&lang=js"
import style0 from "./fiche.vue?vue&type=style&index=0&id=84b481f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports